var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-icon",class:{ overlay: _vm.overlay }},[_c('div',{staticClass:"lds-ellipsis"},_vm._l((4),function(n){return _c('div',{key:n})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }